module.exports = __webpack_public_path__ + "static/img/z5.1d98d4b2.png";